import { dsoCheckoutService } from 'services';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { SaveOrderAddressParams } from 'types/dso/DsoCheckout.types';
import { Dispatch, SetStateAction } from 'react';
import { CheckoutStates } from 'components/DSO/DSOOrderCheckout/DSOOrderCheckout.types';

export const useDsoSaveOrderAddress = (
  setOrderStep: Dispatch<SetStateAction<CheckoutStates>>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    ServerStateKeysEnum.dsoSaveOrderAddressMutation,
    ({ addressPairs }: SaveOrderAddressParams) => {
      return dsoCheckoutService.saveAddress(addressPairs);
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
        setOrderStep('delivery');
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
